import request from '@/router/axios'

export function getUserInfoCode(obj) {
    return request({
        url: '/myams/api/OAuth2/BaseCallback',
        method: 'post',
        data: obj
    })
}
export function getSignatureInfo(obj) {
    return request({
        url: '/myams/api/WeixinJSSDK/GetSignatureInfo',
        method: 'post',
        data: obj
    })
}

// 认证工程师
export function subBindEng(obj) {
    return request({
        url: '/myams/api/User/BindEng',
        method: 'post',
        data: obj
    })
}
// 工程师打卡
export function userClockIn(obj) {
    return request({
        url: '/myams/api/User/ClockIn',
        method: 'post',
        data: obj
    })
}
//  根据经纬度获取详细地址
export function getaddressByLatLon(obj) {
    return request({
        url: '/myams/api/WeixinJSSDK/GetaddressByLatLon',
        method: 'get',
        params: obj
    })
}
// 最近打卡记录
export function userClockInQry(obj) {
    return request({
        url: '/myams/api/User/ClockInQry',
        method: 'post',
        data: obj
    })
}


// 现场工作
// ClassName 项目中心管理 centerList 片区管理 areaList 工作类型 workList  
export function getItemListValue(obj) {
    return request({
        url: '/myams/api/ItemsData/GetItemListValue',
        method: 'post',
        params: obj
    })
}
// 资产查询
export function userAssetsDetails(obj) {
    return request({
        url: '/myams/api/User/AssetsDetails',
        method: 'post',
        data: obj
    })
}
// 现场工作查询
export function userMaintenanceDetails(obj) {
    return request({
        url: '/myams/api/User/MaintenanceDetails',
        method: 'post',
        data: obj
    })
}
// 提交现场工作
export function userMaintenance(obj) {
    return request({
        url: '/myams/api/User/Maintenance',
        method: 'post',
        data: obj
    })
}


// WEBPACK FOOTER //
// ./src/api/index.js